import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import { ResourceTypeDto } from '../Types/ResourceTypeDto'
import ResourceType from '../Classes/ClvrResourceType'

export class ResourceTypeApiAdapter implements ApiDataAdapter<ResourceType> {
    public createClass(apiData: ResourceTypeDto): ResourceType {
        return new ResourceType({
            id: get(apiData, 'id'),
            label: get(apiData, 'libelle'),
        })
    }
}
